<template>
  <th v-if="isHeader">
    <!--  -->
    Actions
  </th>
  <td v-else>
    <div>
      <dropdown>
        <dropdown-action success icon="edit" @click="onClickEdit">Edit link</dropdown-action>

        <dropdown-action
          danger
          icon="delete"
          @click="onClickDelete"
        >Delete link</dropdown-action>
      </dropdown>
    </div>
  </td>
</template>

<script>
import Dropdown from "./Dropdown";
import DropdownAction from "./DropdownAction";

import TrAction from "./TableRowAction";

import VuetableFieldMixin from "vuetable-2/src/components/VuetableFieldMixin";

export default {
  name: "user-actions",

  props: {
    rowData: Object
  },

  methods: {
    onClickEdit() {
     this.$router.push({ name: "CurrentUserQuickLinksEdit", params: {id: this.rowData.id} });
    },

    

    onClickDelete() {
      const vm = this;
      this.$store.dispatch("createDialog", {
        // TODO: This does the right thing, but do we need to create its own
        // method in the store so we can alter the confirmation etc.?
        confirm: () => {
          this.$store
            .dispatch("users/removeQuickLink", vm.rowData.id
            )
            .then(resp => {
              this.$store.dispatch("users/getQuickLinks");
            });
        }
      });
    }
  },

  components: {
    Dropdown,
    DropdownAction,
    TrAction
  },

  mixins: [VuetableFieldMixin]
};
</script>
